import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Tag,
  Descriptions,
  Button,
  Tabs,
  Avatar,
  Modal,
  Spin,
  Typography,
} from "antd";
import {
  UserOutlined,
  FileTextOutlined,
  ArrowRightOutlined,
  ToTopOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import axios from "axios";

const { TabPane } = Tabs;
const { Title } = Typography;

const BASE_URL = "http://93.127.203.113:5005/";

const DriversDetail = () => {
  const { id } = useParams();
  const [driver, setDriver] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  useEffect(() => {
    fetchDriverDetails();
  }, [id]);

  const fetchDriverDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}drivers/${id}`);
      setDriver(response.data.driver);
    } catch (error) {
      console.error("Error fetching driver details:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderImage = (src, alt, placeholderIcon) => (
    src ? (
      <img
        src={`${BASE_URL}${src}`}
        alt={alt}
        style={{
          width: "100%",
          height: "300px",
          objectFit: "cover",
          borderRadius: "10px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        onClick={() => {
          setPreviewImage(`${BASE_URL}${src}`);
          setPreviewVisible(true);
        }}
      />
    ) : (
      <Avatar
        shape="square"
        icon={placeholderIcon}
        style={{
          width: "100%",
          height: "300px",
          borderRadius: "10px",
          backgroundColor: "#f0f2f5",
        }}
      />
    )
  );

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card
          style={{
            marginBottom: "20px",
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            borderTop: "5px solid #0c8c49",
          }}
        >
          <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
            Driver Details
          </Title>
          <Tabs defaultActiveKey="1" type="card" tabBarStyle={{ color: "#aa0077" }}>
            {/* Overview Tab */}
            <TabPane tab={<span><UserOutlined /> Overview</span>} key="1">
              <Descriptions bordered column={2} style={{ marginBottom: "20px" }}>
                <Descriptions.Item label="Driver ID">{driver?.id || "N/A"}</Descriptions.Item>
                <Descriptions.Item label="Name">
                  {`${driver?.firstName || "N/A"} ${driver?.lastName || ""}`}
                </Descriptions.Item>
                <Descriptions.Item label="Phone">
                  {driver?.phoneNumber || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  <Tag
                    color={
                      driver?.status === "Active"
                        ? "#0c8c49"
                        : driver?.status === "Pending"
                        ? "#aa0077"
                        : "red"
                    }
                  >
                    {driver?.status?.toUpperCase() || "N/A"}
                  </Tag>
                </Descriptions.Item>
              </Descriptions>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Title level={5} style={{ color: "#aa0077" }}>Driver Image</Title>
                  {renderImage(driver?.driverImage, "Driver Image", <UserOutlined />)}
                </Col>
              </Row>
            </TabPane>

            {/* Documents Tab */}
            <TabPane tab={<span><FileTextOutlined /> Documents</span>} key="2">
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Title level={5} style={{ color: "#0c8c49" }}>Driver Licence</Title>
                  {renderImage(driver?.driverLicence, "Driver Licence", <ToTopOutlined />)}
                </Col>
                <Col span={12}>
                  <Title level={5} style={{ color: "#0c8c49" }}>Uploaded Documents</Title>
                  {renderImage(driver?.documents, "Document", <FileTextOutlined />)}
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </Card>
      )}

      {/* Preview Modal */}
      <Modal
        visible={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="Preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  );
};

export default DriversDetail;
